exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumbs-root ol {\n  height: 41px;\n  padding: 0.5rem 1rem;\n  margin: 0;\n  background-color: white; }\n  .breadcrumbs-root ol.breadcrumb {\n    color: #69BC73;\n    cursor: pointer; }\n  .breadcrumbs-root ol .breadcrumb-item {\n    text-transform: capitalize; }\n  .breadcrumbs-root ol .breadcrumb-item.active {\n    cursor: text; }\n", ""]);

// exports
